import { render, staticRenderFns } from "./SourceData.vue?vue&type=template&id=37ba7761&scoped=true"
import script from "./SourceData.vue?vue&type=script&lang=js"
export * from "./SourceData.vue?vue&type=script&lang=js"
import style0 from "./SourceData.vue?vue&type=style&index=0&id=37ba7761&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ba7761",
  null
  
)

export default component.exports